import { h } from "preact";
import { useState, useEffect } from "preact/hooks";

import { makeStyles } from "@mui/styles";
import { Grid, Typography, TextField, FormControl, Select, MenuItem, Box, Paper } from "@mui/material";
import NavPrimaryButtonMk2 from "../../theme/NavPrimaryButtonMk2";
import palette from "../../theme/palette";

const useStyles = makeStyles((theme) => ({
	root: {
		display: "flex",
		flexWrap: "wrap",
	},
	textField: {
		marginLeft: theme.spacing(1),
		marginRight: theme.spacing(1),
		width: "25ch",
	},
	formControl: {
		margin: theme.spacing(1),
		marginLeft: 0,
		minWidth: 120,
		width: "100%",
	},
}));

export default function Contact() {
	const classes = useStyles();

	const [formData, setFormData] = useState({
		lastname: "",
		firstname: "",
		email: "",
		comment: "",
		cat: 0,
	});

	const [types, setTypes] = useState([]);
	const [submitted, setSubmitted] = useState(false);
	const [complete, setComplete] = useState(false);
	const handleChange = (event) => {
		setCat(event.target.value);
	};

	const manageSubmit = () => {
		console.log("manageSubmit");
		setSubmitted(true);
		const requestOptions = {
			method: "POST",
			headers: { "Content-Type": "application/json" },

			body: JSON.stringify({
				lname: formData.lastname,
				fname: formData.firstname,
				email: formData.email,
				comment: formData.comment,
				cat: formData.cat,
			}),
		};
		fetch("/api/contact", requestOptions)
			.then((response) => {
				return response.json();
			})
			.then((res) => {
				switch (res.res) {
					case "ok":
						break;
					case "err":
						break;
					default:
						break;
				}
			});
	};
	const handleChange2 = (event) => {
		setFormData({ ...formData, [event.target.name]: event.target.value }, () => {
			console.log("done");
		});
	};
	function ValidateEmail(email) {
		if (/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(email)) {
			return true;
		}

		return false;
	}

	useEffect(() => {
		if (
			formData.comment !== "" &&
			formData.firstname !== "" &&
			formData.lastname != "" &&
			formData.cat !== undefined &&
			ValidateEmail(formData.email)
		) {
			setComplete(true);
		} else {
			setComplete(false);
		}
	}, [formData]);

	useEffect(() => {
		fetch("/api/contact_types")
			.then((response) => {
				return response.json();
			})
			.then((res) => {
				switch (res.res) {
					case "ok":
						setTypes(res.pld);
						break;
					case "err":
						break;
					default:
						break;
				}
			});
	}, []);
	return (
		<Box display="flex" justifyContent="center" m={1} p={1}>
			<Box p={1}>
				<Paper style={`padding: 15px; min-width: 350px; background-color: ${palette.lightgray}`} elevation={3}>
					<Grid container>
						{!submitted && (
							<Grid item xs={12}>
								<div>
									<Typography variant="h1" style="margin-bottom: 10px;">
										Formulaire de contact
									</Typography>
									<Typography variant="subtitle2">Tous les champs sont obligatoires</Typography>
								</div>
								<div>
									<TextField
										id="firstname"
										name="firstname"
										variant="outlined"
										style={{
											marginLeft: 0,
											marginRight: 10,
										}}
										placeholder="Nom"
										fullWidth
										margin="dense"
										value={formData.firstname}
										onChange={handleChange2}
									/>
								</div>
								<div>
									<TextField
										id="lastname"
										name="lastname"
										variant="outlined"
										style={{
											marginLeft: 0,
											marginRight: 10,
										}}
										placeholder="Prénom"
										fullWidth
										margin="dense"
										value={formData.lastname}
										onChange={handleChange2}
									/>
								</div>

								<div>
									<TextField
										id="email"
										name="email"
										variant="outlined"
										style={{
											marginLeft: 0,
											marginRight: 10,
										}}
										placeholder="Email"
										fullWidth
										margin="dense"
										value={formData.email}
										onChange={handleChange2}
									/>
								</div>

								<div>
									<FormControl variant="outlined" className={classes.formControl}>
										<Select labelId="cat-label" id="cat" name="cat" value={formData.cat} onChange={handleChange2} margin="dense">
											<MenuItem value={0}>
												<em>Votre question concerne ...</em>
											</MenuItem>
											{types.map((t) => {
												return <MenuItem value={t.c}>{t.d}</MenuItem>;
											})}
											}
										</Select>
									</FormControl>
								</div>
								<div>
									<TextField
										id="comment"
										name="comment"
										variant="outlined"
										style={{
											marginLeft: 0,
											marginRight: 10,
										}}
										placeholder="Dîtes-nous en plus"
										fullWidth
										multiline
										rows="3"
										margin="dense"
										value={formData.comment}
										onChange={handleChange2}
									/>
								</div>
								<div>
									<Typography variant="caption" display="block">
										Bkeys traite les données recueillies pour répondre le plus efficacement à votre demande...
									</Typography>
									<Typography variant="caption" display="block">
										Pour en savoir plus sur la gestion de vos données personnelles et pour exercer vos droits, reportez-vous à
										notre politique de confidentialité.
									</Typography>
								</div>
								<div>
									<NavPrimaryButtonMk2 cb={manageSubmit} disabled={!complete} txt="Envoyer >" />
								</div>
							</Grid>
						)}
						{submitted && (
							<Grid item xs={12}>
								<div>
									<Typography variant="h4">
										Merci pour votre question, {formData.firstname}, nous ne manquerons pas de vous répondre aussi vite que le
										vent
									</Typography>
								</div>
							</Grid>
						)}
					</Grid>
				</Paper>
			</Box>
		</Box>
	);
}
